import React, { useEffect, useState } from 'react';
import { Loader2, Radar } from 'lucide-react';
import { motion } from 'framer-motion';
import { BrandTopNav } from './BrandTopNav';
import { trackerGet, errMsg } from './trackerApi';

// Shell for all tracker pages: top nav + account guard. Children get the account via render prop.
export const TrackerLayout = ({ title, subtitle, actions, children }) => {
  const [account, setAccount] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { trackerGet('/me').then(setAccount).catch((e) => setError(errMsg(e, 'Could not load your account'))); }, []);

  return (
    <div className="min-h-screen bg-white text-[#0F0F0F]" data-testid="brand-tracker-shell">
      <BrandTopNav brandName={account?.brand_name || ''} />
      <main className="max-w-[1400px] mx-auto px-8 py-10">
        {error ? (
          <div className="max-w-lg mx-auto text-center py-24" data-testid="brand-tracker-no-account">
            <Radar className="mx-auto text-[#FF451A] mb-4" size={36} />
            <h2 className="text-2xl font-bold mb-2">Competitor tracking isn't set up yet</h2>
            <p className="text-sm text-[#6B6B6B]">{error}. Ask your Vyvre account manager to enable it for your brand.</p>
          </div>
        ) : !account ? (
          <div className="flex items-center gap-2 text-sm text-[#6B6B6B] py-24 justify-center"><Loader2 size={16} className="animate-spin text-[#FF451A]" /> Loading…</div>
        ) : (
          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
            <div className="flex items-end justify-between gap-4 mb-8 flex-wrap">
              <div>
                <div className="text-xs font-semibold uppercase tracking-[0.14em] text-[#FF451A] mb-2">{account.brand_name} · Competitor Intelligence</div>
                <h1 className="text-4xl sm:text-5xl font-bold tracking-tight" data-testid="brand-tracker-title">{title}</h1>
                {subtitle && <p className="text-[#6B6B6B] mt-2">{subtitle}</p>}
              </div>
              {actions}
            </div>
            {children(account)}
          </motion.div>
        )}
      </main>
    </div>
  );
};
